
import EventCardHospital from '@/components/block/EventCardHospital.vue'
import { defineComponent } from '@vue/runtime-core'

export default defineComponent({
  components: {
    EventCardHospital
  },

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
})
